import { Component, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { BffService } from '../../services/BffService';

@Component({
  selector: 'app-auth-selection',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatCardModule, MatIconModule],
  templateUrl: './auth-selection.component.html',
  styleUrl: './auth-selection.component.css',
  encapsulation: ViewEncapsulation.None
})
export class AuthSelectionComponent {

  constructor(
    private bffService: BffService,
    private router: Router
  ) {}

  signInCustomer(): void {
    this.bffService.signInCustomer();
  }

  signInEmployee(): void {
    this.bffService.signInEmployee();
  }

  signUpCustomer(): void {
    // Redirect to customer registration via Azure CIAM user flow
    this.bffService.signInCustomer(); // This will go through the Azure CIAM sign-up flow
  }
}
